<template>
	<core-page bannerTitle="Reference" title="UI Reference">
		<div style="margin-bottom: 30px;" ref="wrap">
			<button @click.prevent="toggleAll">Toggle all</button>
			<nav>
				<ul id="ref-nav">
					<li v-for="elId in nav" :key="elId">
						<a :href="`#${elId}`">{{ elId }}</a>
					</li>
				</ul>
			</nav>
			<details id="icons-ref" open="open">
				<summary><h2>Icons</h2></summary>
				<div class="omapi-action">Class: <pre style="display: inline">'omapi-action'</pre></div>
				<div class="omapi-info">Class: <pre style="display: inline">'omapi-info'</pre></div>
				<div class="omapi-warning">Class: <pre style="display: inline">'omapi-warning'</pre></div>
				<div class="omapi-success">Class: <pre style="display: inline">'omapi-success'</pre></div>
				<div class="omapi-success inverted">Class: <pre style="display: inline">'omapi-success inverted'</pre></div>
				<div class="omapi-redx">Class: <pre style="display: inline">'omapi-redx'</pre></div>
				<div class="omapi-redx hollow">Class: <pre style="display: inline">'omapi-redx hollow'</pre></div>
				<div class="omapi-rocket">Class: <pre style="display: inline">'omapi-rocket'</pre></div>
				<div class="omapi-rocket rocket-blue">Class: <pre style="display: inline">'omapi-rocket rocket-blue'</pre></div>
				<div class="omapi-book">Class: <pre style="display: inline">'omapi-book'</pre></div>
				<div class="omapi-document">Class: <pre style="display: inline">'omapi-document'</pre></div>
				<div class="omapi-help">Class: <pre style="display: inline">'omapi-help'</pre></div>
				<div class="omapi-help help-white">Class: <pre style="display: inline">'omapi-help help-white'</pre></div>
				<div class="omapi-help help-white inverted">Class: <pre style="display: inline">'omapi-help help-white inverted'</pre></div>
				<div class="omapi-university">Class: <pre style="display: inline">'omapi-university'</pre></div>
				<div class="omapi-inbox">Class: <pre style="display: inline">'omapi-inbox'</pre></div>
				<div class="omapi-inbox solid">Class: <pre style="display: inline">'omapi-inbox solid'</pre></div>
			</details>
			<details id="buttons-ref" open="open">
				<summary><h2>Buttons</h2></summary>
				<core-button color="green">Primary Green Small</core-button>
				<core-button size="large" color="green">Primary Green Large</core-button>
				<core-button type="secondary">Secondary Small</core-button>
				<core-button size="large">Primary Large</core-button>

				<core-button size="medium"
							color="blue"
							type="secondary"
							:isLink="true"
							href="https://example.com"
							target="_blank">Secondary Blue Medium Link
				</core-button>
				<core-button :linkStyle="true">Link Style Button</core-button>
			</details>
			<details id="tooltip-ref" open="open">
				<summary><h2>Tooltip</h2></summary>
				<common-tooltip
					tooltip="Tooltip message goes here"
				>
						<span>Item with tooltip</span>
				</common-tooltip>
			</details>
			<details id="alert-ref" open="open">
				<summary><h2>Alert Boxes</h2></summary>
				<common-alerts id="om-plugin-alerts" :alerts="testAlerts"/>

				<core-alert type="warn">
					<div class="alert-message">
						<span class="omapi-alert__primary">Updating this provider could affect any connected campaigns.</span> If you have connected campaigns, please check that all lists and options are still set properly for those campaigns.<br>This alert has a lot of text. How does it flow? Testing, testing 1, 2, 3. The quick brown fox jumped over the lazy dog. At least that's how I think it goes. A long time ago, in a galaxy far away...
					</div>
				</core-alert>

			</details>
			<details id="cards-ref" open="open">
				<summary><h2>Cards</h2></summary>
				<div class="omapi-card__flex">
					<common-card title="Full width card permanent (Title)">
						Content
						<template v-slot:footer>Footer</template>
					</common-card>
					<common-card type="dismiss">
						No Title, dismissable
						<template v-slot:footer>Footer</template>
					</common-card>
					<common-card type="dismiss" title="Full width card dismissable (Title)">
						Content
						<template v-slot:footer>Footer</template>
					</common-card>
					<common-card type="minimize" title="Full width card minimizable (Title)">
						Content
						<template v-slot:footer>Footer</template>
					</common-card>
					<common-card size="half" title="Half width card (Title)">
						Content
						<template v-slot:footer>Footer</template>
					</common-card>
					<common-card size="half" title="(8) New Notifications">
						<ul class='omapi-detailed-list'>
							<li class='omapi-success'>
								<div class='omapi-multi-column__primary'>
									<div class='omapi-multi-column__title'>We’ve just added a new feature to OptinMonster.</div>
									<div class='omapi-multi-column__text'>Morbi purus justo, tristique eget ligula in, sodales interdum nisl.</div>
									<div class='omapi-multi-column__buttons'>
										<core-button type="secondary" size="small">Learn More</core-button>
										<core-button :linkStyle="true">Dismiss</core-button>
									</div>
								</div>
								<div class='omapi-multi-column__secondary upper'>3 days ago</div>
							</li>
							<li class='omapi-action'>
								<div class='omapi-multi-column__primary'>
									<div class='omapi-multi-column__title'>There is an error with your account.</div>
									<div class='omapi-multi-column__text'>Morbi purus justo, tristique eget ligula in, sodales interdum nisl.</div>
									<div class='omapi-multi-column__buttons'>
										<core-button type="secondary" size="small">Fix Now</core-button>
										<core-button :linkStyle="true">Dismiss</core-button>
									</div>
								</div>
								<div class='omapi-multi-column__secondary upper'>6 days ago</div>
							</li>
							<li class='omapi-warning'>
								<div class='omapi-multi-column__primary'>
									<div class='omapi-multi-column__title'>You haven’t finished setting up your site.</div>
									<div class='omapi-multi-column__text'>Morbi purus justo, tristique eget ligula in, sodales interdum nisl.</div>
									<div class='omapi-multi-column__buttons'>
										<core-button type="secondary" size="small">Edit Settings</core-button>
										<core-button :linkStyle="true">Dismiss</core-button>
									</div>
								</div>
								<div class='omapi-multi-column__secondary upper'>12 days ago</div>
							</li>
						</ul>
						<template v-slot:footer>
							<a href='#' class='omapi-link-arrow-after'>You have 5 more notifications</a>
							<a href='#'>Dismiss All</a>
						</template>
					</common-card>
					<common-card size="third" title="One third width card (Title)" >
						Content
						<template v-slot:footer>Footer</template>
					</common-card>
					<common-card size="third">
						<template v-slot:title>One third width card (Title)</template>
						<ul class='omapi-detailed-list'>
							<li>
								<div class='omapi-multi-column__primary'>
									<div class='omapi-multi-column__title'><a href='#' class='omapi-link-title'>My Amazing Campaign Name Goes Here</a></div>
									<ul class='omapi-multi-column__meta'>
										<li><span class='omapi-multi-column__meta-attr'>Visitors: </span><span class='omapi-multi-column__meta-value'>1,077</span></li>
										<li><span class='omapi-multi-column__meta-attr'>Conversions: </span><span class='omapi-multi-column__meta-value'>42</span></li>
										<li><span class='omapi-multi-column__meta-attr'>CR%: </span><span class='omapi-multi-column__meta-value'>3.9%</span></li>
									</ul>
								</div>
							</li>
							<li>
								<div class='omapi-multi-column__primary'>
									<div class='omapi-multi-column__title'><a href='#' class='omapi-link-title'>My Amazing Campaign Name Goes Here</a></div>
									<ul class='omapi-multi-column__meta'>
										<li><span class='omapi-multi-column__meta-attr'>Visitors: </span><span class='omapi-multi-column__meta-value'>1,077</span></li>
										<li><span class='omapi-multi-column__meta-attr'>Conversions: </span><span class='omapi-multi-column__meta-value'>42</span></li>
										<li><span class='omapi-multi-column__meta-attr'>CR%: </span><span class='omapi-multi-column__meta-value'>3.9%</span></li>
									</ul>
								</div>
							</li>
							<li>
								<div class='omapi-multi-column__primary'>
									<div class='omapi-multi-column__title'><a href='#' class='omapi-link-title'>My Amazing Campaign Name Goes Here</a></div>
									<ul class='omapi-multi-column__meta'>
										<li><span class='omapi-multi-column__meta-attr'>Visitors: </span><span class='omapi-multi-column__meta-value'>1,077</span></li>
										<li><span class='omapi-multi-column__meta-attr'>Conversions: </span><span class='omapi-multi-column__meta-value'>42</span></li>
										<li><span class='omapi-multi-column__meta-attr'>CR%: </span><span class='omapi-multi-column__meta-value'>3.9%</span></li>
									</ul>
								</div>
							</li>
							<li>
								<div class='omapi-multi-column__primary'>
									<div class='omapi-multi-column__title'><a href='#' class='omapi-link-title'>My Amazing Campaign Name Goes Here</a></div>
									<ul class='omapi-multi-column__meta'>
										<li><span class='omapi-multi-column__meta-attr'>Visitors: </span><span class='omapi-multi-column__meta-value'>1,077</span></li>
										<li><span class='omapi-multi-column__meta-attr'>Conversions: </span><span class='omapi-multi-column__meta-value'>42</span></li>
										<li><span class='omapi-multi-column__meta-attr'>CR%: </span><span class='omapi-multi-column__meta-value'>3.9%</span></li>
									</ul>
								</div>
							</li>
							<li>
								<div class='omapi-multi-column__primary'>
									<div class='omapi-multi-column__title'><a href='#' class='omapi-link-title'>My Amazing Campaign Name Goes Here</a></div>
									<ul class='omapi-multi-column__meta'>
										<li><span class='omapi-multi-column__meta-attr'>Visitors: </span><span class='omapi-multi-column__meta-value'>1,077</span></li>
										<li><span class='omapi-multi-column__meta-attr'>Conversions: </span><span class='omapi-multi-column__meta-value'>42</span></li>
										<li><span class='omapi-multi-column__meta-attr'>CR%: </span><span class='omapi-multi-column__meta-value'>3.9%</span></li>
									</ul>
								</div>
							</li>
						</ul>
						<template v-slot:footer>
							<a href='#' class='omapi-link-arrow-after'>View All Campaigns</a>
						</template>
					</common-card>
					<common-card size="third" title="One third width card (Title)">
						Content
						<template v-slot:footer>Footer</template>
					</common-card>
					<common-card size="fourth" title="One fourth width card (Title)">
						Content
						<template v-slot:footer>Footer</template>
					</common-card>
					<common-card
						size="fourth"
						title="One fourth width card (Title)"
						contentClass="omapi-card__border"
					>
						<div class='omapi-multi-column omapi-flex omapi-flex-row'>
							<div class='omapi-multi-column__secondary omapi-icon-wrapper omapi-icon-wrapper__left'>
								<img src='../assets/images/logo-wpforms.png' alt='WPForms Logo'>
							</div>
							<div class='omapi-multi-column__primary'>
								<div class='omapi-multi-column__title'>WPForms</div>
								<div class='omapi-multi-column__text'>Make sure your website's emails reach the inbox. Our goal is to make email deliverability easy and reliable. Trusted by over 1 million websites.</div>
							</div>
						</div>
						<template v-slot:footer>
							<div class='omapi-status'>
								<span class='omapi-multi-column__meta-attr'>Status: </span>
								<span class='omapi-multi-column__meta-value omapi-multi-column__meta-green'>Active</span>
							</div>
							<CoreButton type='secondary'>Activated</CoreButton>
						</template>
					</common-card>
					<common-card size="fourth" title="One fourth width card (Title)">
						Content
						<template v-slot:footer>Footer</template>
					</common-card>
					<common-card size="fourth" title="One fourth width card (Title)">
						Content
						<template v-slot:footer>Footer</template>
					</common-card>
				</div>
			</details>
			<details id="dropdown-ref" open="open">
				<summary><h2>Dropdown Selects</h2></summary>
				<div>
					<h3>Date Picker</h3>
					<core-form-datepicker-input
						label="Date Range Picker Example"
						class="omapi-input"
						:dateRange="dateVal"
					/>
					<h3>Dropdown Select</h3>
					<core-dropdown-select align="right" :currentValue="dateRange.value">
						<template v-slot:list>
							<li><a
								href="#"
								@click.prevent="updateStats({ key   : 'last7', value : 'Last 7 Days'})"
								:class="{'current' : 'last7' === dateRange.key}"
							>
								Last 7 Days
							</a></li>
							<li><a
								href="#"
								@click.prevent="updateStats({ key   : 'last30', value : 'Last 30 Days'})"
								:class="{'current' : 'last30' === dateRange.key}"
							>
								Last 30 Days
							</a></li>
							<li><a
								href="#"
								@click.prevent="updateStats({ key   : 'custom', value : 'Custom Date Range'})"
								:class="{'current' : 'custom' === dateRange.key}"
							>
								Custom Date Range
							</a></li>
						</template>
					</core-dropdown-select>
					<h3>Dropdown Button</h3>
					<core-dropdown-button class="campaign-table-additional-actions" align="left">
						<template v-slot:list>
							<li><a href="#" @click.prevent="dropdownButton('archive')">Archive</a></li>
							<li><a href="#" @click.prevent="dropdownButton('embed')">Get Embed Code</a></li>
							<li><a href="#" @click.prevent="dropdownButton('monster-link')">Shareable Link</a></li>
						</template>
					</core-dropdown-button>
					<h3>Multi-select Dropdown</h3>
					<core-form-multi-select-input
						:options="testOptions"
						class="omapi-input"
						searchPlaceholder="Type to search for pizza toppings"
					/>
					<h3>Image-based Dropdown</h3>
					<h3>Select2 Dropdown</h3>
				</div>
			</details>
			<details id="ui-elements-ref" open="open">
				<summary><h2>UI Elements</h2></summary>
				<section>
					<p><code>campaigns-shortcode-box</code></p>
					<p><strong>Example:</strong></p>
					<pre>
	&lt;campaigns-shortcode-box campaignSlug="&lt;CAMPAIGN_SLUG>"/>
					</pre>
					<p><strong>Working Example:</strong></p>
					<campaigns-shortcode-box campaignSlug="fauxCampaign.id"/>
				</section>
				<section>
					<p><code>common-codebox</code></p>
					<p><strong>Example:</strong></p>
					<pre>
	&lt;common-codebox>
		This is stuff you want to live in the code box
	&lt;/common-codebox>
					</pre>
					<p><strong>Working Example:</strong></p>
					<common-codebox>
						This is stuff you want to live in the code box
					</common-codebox>
				</section>
				<section>
					<p><code>common-copy-link</code></p>
					<p><strong>Example:</strong></p>
					<pre>
	&lt;common-copy-link
		toolTipText="Click to copy this campaign slug."
		copiedTooltipText="Campaign slug copied!"
	>
		vitxdwjrgfu8xyeweoqz
	&lt;/common-copy-link>
					</pre>
					<p><strong>Working Example:</strong></p>
					<common-copy-link
						toolTipText="Click to copy this anchor text."
					>
						This is the anchor text that will be copied, used for things like copying campaign slugs.
					</common-copy-link>
					e.g.
					<common-copy-link
						toolTipText="Click to copy this campaign slug."
						copiedTooltipText="Campaign slug copied!"
					>
						vitxdwjrgfu8xyeweoqz
					</common-copy-link>
				</section>
				<p>
					<common-toggle-input onText="Yes" offText="No"/>
				</p>
				<p>
					<a href="#" class="omapi-link-arrow-before">
						Return to Campaigns List
					</a>
				</p>
				<p>
					<a href="#" class="omapi-link-arrow-after">
						Continue to Campaigns List
					</a>
				</p>
				<i class="omapi-icon omapi-icon__eye"></i>
				<i class="omapi-icon omapi-icon__copy"></i>
				<i class="omapi-icon omapi-icon__trash"></i>
				<i class="omapi-icon omapi-icon__ellipsis"></i>
				<i class="omapi-icon omapi-icon__pencil"></i>
				<i class="omapi-icon omapi-icon__envelope"></i>
				<details open="open">
					<summary><h2>Radio Buttons Components</h2></summary>
					<common-selectable-group
						groupName="omapi-radios"
						:options="[
							{
								label: 'Manual',
								value: 'manual',
								help: 'Add where you would like to display your campaign.',
							},
							{
								label: 'Automatic',
								value: 'manual',
								help: 'Select where your campaign will go.',
								checked: true,
							},
						]"
					/>

					<div class="omapi-radio-group omapi-radio-group__indent omapi-radio-group__with-inputs">
						<common-selectable-input name="omapi-radios-indented" value="words">
							After
							<input type="text" width="3" value="300"/>
							Words
						</common-selectable-input>
						<common-selectable-input name="omapi-radios-indented" value="automatic" :checked="true">
							After
							<input type="text" width="3" placeholder="3"/>
							Paragraphs
						</common-selectable-input>
						<common-selectable-input name="omapi-radios-indented" value="automatic" label="Below Post"/>
						<common-selectable-input name="omapi-radios-indented" value="automatic" label="Above Post"/>
					</div>
				</details>
				<details open="open">
					<summary><h2>Checkbox Component</h2></summary>
					<common-selectable-group
						groupName="omapi-checkboxes"
						type="checkbox"
						:options="[
							{
								label: 'Shoes',
								value: 'shoes',
								help: 'Select where your campaign will go.',
								checked: true,
							},
							{
								label: 'Sale',
								value: 'sale',
							},
						]"
					/>
				</details>
				<details open="open">
					<summary><h2>Pagination</h2></summary>
					<core-pagination
						:pageTotal="26"
						:total="60"
						:page="2"
					/>

					<div class="omapi-pagination omapi-pagination__style-2">
						<a href="" class="omapi-button omapi-pagination__button omapi-pagination__button-inactive">1</a>
						<a href="" class="omapi-button omapi-pagination__button">2</a>
						<a href="" class="omapi-button omapi-pagination__button">3</a>
						<a href="" class="omapi-button omapi-pagination__button">4</a>
					</div>
				</details>
				<details open="open">
					<summary><h2>Progress</h2></summary>
					<common-progress-steps
						:completed="2"
						:total="5"
					/>
				</details>
			</details>
			<details open="open">
				<summary><h2>Campaign Output Settings</h2></summary>
				<core-save-button
					color="green"
					:saving="loading === 'campaign-save'"
					@click.prevent="campaignSave"
				/>

				<campaigns-users-setting :campaign="fauxCampaign"/>
				<campaigns-inline-settings :campaign="fauxCampaign"/>
				<campaigns-advanced-settings :campaign="fauxCampaign">
					<core-save-button
						color="green"
						:saving="loading === 'campaign-save'"
						@click.prevent="campaignSave"
					/>
				</campaigns-advanced-settings>
				<campaigns-rule-summary-wrap :campaign="fauxCampaign"/>

			</details>
		</div>
	</core-page>
</template>

<script>
import filter from 'lodash/filter'
import moment from 'moment'

const message = (type = null) => {
	const primary = type ? `This is a "${type}" alert type.` : 'This is an alert with no type.'
	return `<span class="omapi-alert__primary">${primary}</span> If you have connected campaigns, please check that all lists and options are still set properly for those campaigns.`
}

export default {
	name : 'UIRef',
	data () {
		return {
			testAlerts : [
				{
					type    : 'success',
					message : message('success'),
				},
				{
					type    : 'error',
					message : message('error'),
				},
				{
					type    : 'info',
					message : message('info'),
				},
				{
					type    : 'warn',
					message : message('warn'),
				},
				{
					// type : none
					message : message(),
				},
			],
			testOptions : [
				{
					name  : 'option 1',
					value : 1,
				},
				{
					name  : 'option 2',
					value : 2,
				},
				{
					name  : 'option 3',
					value : 3,
				},
			],
			dateRange : {
				// Default
				key   : 'last7',
				value : 'Last 7 Days',
			},
			loading      : '',
			fauxCampaign : {
				id : '<CAMPAIGN_SLUG>',
				wp : {
					post_meta : {
						_omapi_enabled   : '1',
						_omapi_users     : 'in',
						_omapi_automatic : '1',
						_omapi_only      : [ 22 ],
					},
				},
				rulesets : [ { id: 'fxr2iszqts0zwobj0p57', name: 'Default Ruleset', created_at: '2020-03-04 20:31:57', updated_at: '2020-03-04 20:31:57', groups: [ { id: 'eAKAjdIbChFPLRES9bQD', order: 0, created_at: '2020-03-04 20:31:57', updated_at: '2020-03-04 20:31:57', rules: [ { id: 'f3NxhAps0rOCXHmdTNSj', order: 0, type: 'url-path', operator: 'url-any', value: '', unit: '', created_at: '2020-03-04 20:31:57', updated_at: '2020-03-04 20:31:57' }, { id: 'k1K9heiJswIk7ttqlj3k', order: 0, type: 'campaign-optin', operator: 'opted-folder', value: [ '5f57f026a539a', '5e8f3a5371c7f' ], unit: '0', created_at: '2020-09-16 19:29:22', updated_at: '2020-09-22 20:22:17' } ] }, { id: 'ZpR1egIm2ggClEqsUA1q', order: 0, created_at: '2020-09-16 15:57:58', updated_at: '2020-09-16 15:57:58', rules: [ { id: 'OXXINiUp5cpGyPqluPlH', order: 0, type: 'html-element-exists', operator: 'not-match-selector', value: 'pizza', unit: '0', created_at: '2020-09-16 15:57:58', updated_at: '2020-09-16 15:57:58' } ] }, { id: 'xpAaZpBuxjn61CIvL38n', order: 0, created_at: '2020-09-16 15:57:58', updated_at: '2020-09-16 15:57:58', rules: [ { id: 'lelcQ4elJg6ov0QNns1x', order: 0, type: 'js-variable', operator: '0', value: { key: { operator: 'exact-match', value: 'pizza' }, value: { operator: 'not-exact-match', value: 'sausage' } }, unit: '0', created_at: '2020-09-16 15:57:58', updated_at: '2020-09-16 15:57:58' }, { id: 'FuNBqG73Fcj9avgGr0cv', order: 0, type: 'campaign-closed', operator: 'opted-campaign', value: [ 'nvgaaqkzpudr21jeaj4f', 'ejfuyl8hiabatnmlfial' ], unit: '0', created_at: '2020-09-22 20:25:36', updated_at: '2020-09-22 20:25:36' }, { id: '1LESdfuxboVjGQ0KP3xn', order: 0, type: 'campaign-not-closed', operator: 'opted-campaign', value: [ 'bfxxd6gqzm1szqekcz26', 'h2hswpbbcki1bubtwwb4' ], unit: '0', created_at: '2020-09-22 20:25:36', updated_at: '2020-09-22 20:25:36' } ] }, { id: 'OPAC8KRPBY7TBIKh3woR', order: 0, created_at: '2020-09-18 13:31:16', updated_at: '2020-09-18 13:31:16', rules: [ { id: '5fXjGxvjpiZZKVsvIKhf', order: 0, type: 'date-time', operator: 'on-after', value: '2020-09-21 00:00:00', unit: '', created_at: '2020-09-18 13:31:16', updated_at: '2020-09-18 13:31:16' }, { id: 'k7nBGzlBLIALExmQP487', order: 0, type: 'campaign-not-seen', operator: 'opted-campaign', value: [ 'hxojdkdlurbdotsqpfo6', 'nvgaaqkzpudr21jeaj4f' ], unit: '0', created_at: '2020-09-22 20:21:59', updated_at: '2020-09-22 20:33:11' } ] } ], actions: [ { id: 'D8NGlicou1ni9zRHBLLM', type: 'show-campaign', operator: '0', value: 'optin', unit: '0', created_at: '2020-03-04 20:31:57', updated_at: '2020-03-04 20:31:57' } ] }, { id: 'fdf8wgry1ks20xrk24km', name: 'Secondary Ruleset', created_at: '2020-09-16 19:29:51', updated_at: '2020-09-16 20:45:58', groups: [ { id: 'J3SuGRwF8t79S8LVbC4U', order: 0, created_at: '2020-09-16 19:29:51', updated_at: '2020-09-16 19:29:51', rules: [ { id: 'q3HYvxxCzJPQMvXKpVsK', order: 0, type: 'page-time', operator: 'more-than-equal-to', value: 5, unit: 'second', created_at: '2020-09-16 19:29:51', updated_at: '2020-09-16 19:29:51' } ] }, { id: 'NT08soOgg3Z5WDx1WvZm', order: 0, created_at: '2020-09-16 19:29:51', updated_at: '2020-09-16 19:29:51', rules: [ { id: 'bHZ1FvzKBuY2vgBcOKGp', order: 0, type: 'url-path', operator: 'url-any', value: '', unit: '', created_at: '2020-09-16 19:29:51', updated_at: '2020-09-16 19:29:51' } ] } ], actions: [ { id: 'gbz8E8S0PanB6HxOPaHo', type: 'show-campaign', operator: '0', value: 'optin', unit: '0', created_at: '2020-09-16 19:29:51', updated_at: '2020-09-16 19:29:51' } ] } ],
			},
			nav : [],
		}
	},
	computed : {
		el () {
			return this.$refs.wrap && this.$refs.wrap.$el ? this.$refs.wrap.$el : this.$refs.wrap || null
		},
		dateVal () {
			const start = moment().subtract(39, 'days')
			const end   = moment().subtract(1, 'weeks').endOf('week')
			return [ start, end ]
		},
	},
	methods : {
		toggleAll () {
			const them = this.el.querySelectorAll('details')
			const close = 0 === filter(them, el => !el.open).length
			them.forEach(el => { el.open = !close })
		},
		updateStats (dateRange) {
			this.dateRange = dateRange
			console.log('Update stats to ' + dateRange.key + ' ' + dateRange.value)
		},
		dropdownButton (value) {
			console.log(value + ' was clicked!')
		},
		campaignSave () {
			this.loading = 'campaign-save'
			setTimeout(() => { this.loading = '' }, 1000)
		},
	},
	mounted () {
		this.el.querySelectorAll('details').forEach(el => {
			if (el.id && -1 === this.nav.indexOf(el.id)) {
				this.nav.push(el.id)
			}
		})
	},
}
</script>

<style lang="scss" scoped>
	#ref-nav {
		display: flex;
		li {
			// padding: 0 5px;
			&:after {
				content: '|';
				padding: 0 7px;
			}
			&last-child:after {
				padding: 0 0 0 7px;
			}
		}

		&:before {
			content: '|';
			padding: 0 7px 0 0;
		}

	}
	summary {
		cursor: pointer;
		h2 {
			display: inline-block;
		}
	}
	section {
		padding: 0 0 1.5em;
		margin: 0 0 1.5em;
		border-bottom: 1px solid #ccc;
	}
</style>
